<template>
    <div class="paxinfo floatleft width100" id="paxinfo">
        <div class="textleft">
            <div v-on:change="showWarningChange">
                <div
                    class="midblock padding15 font14 shadow marginbottom10 red-notification"
                >
                  De namen en gegevens dienen
                  <strong>volgens paspoort</strong> ingevuld te worden. Na het
                  maken van de boeking kunnen wij deze niet meer aanpassen.
                  Velden met een sterretje <span class="rood">*</span> zijn
                  noodzakelijk om deze boeking goed te kunnen verwerken. Heb
                  je een mindervalide (aangepaste) hut nodig of ben je zwanger (tijdens de cruise)? Neem dan eerst contact met ons op :)
                </div>

              <div class="midblock padding15 font14 shadow marginbottom10 red-notification">
                  Heeft één of meerdere reizigers een woonadres buiten het Schengengebied, neem dan eerst telefonisch contact met ons op!
              </div>


                <Passenger
                    v-for="(passenger, index) in paxInfo.collection"
                    :passenger="passenger"
                    :paxInfoLength="paxInfo.collection.length"
                    :paxIndex="index"
                    :showWarnings="showWarnings"
                    :nationalities="nationalities"
                    :countries="countries"
                    :rederijNaam="cruise.rederij_naam"
                    :isEmptyOrNull="isEmptyOrNull"
                    :isInvalidPhoneNumber="isInvalidPhoneNumber"
                    :isInvalidEmail="isInvalidEmail"
                    :isInvalidName="isInvalidName"
                    :age="age"
                    :nameWarn="nameWarn"
                    :emailWarn="emailWarn"
                    :key="'passenger' + index"
                    class="midblock padding15 shadow marginbottom10 tform"
                />

                <div v-if="cruise.rederij_id == 31" class="midblock padding15 shadow marginbottom10 tform">
                    <div class="floatleft width100">
                        <h3 class="font14 nomargin paddingbottom10">Thuisblijver</h3>
                    </div>

                      <div class="flexbox">
                        <div>Naam:
                          <span class="rood">*
                            <span v-if="(showWarnings || isEmptyOrNull(paxInfo.homesteader_name))">We missen een naam.</span>
                            <span v-if="(!isEmptyOrNull(paxInfo.homesteader_name) && isInvalidName(paxInfo.homesteader_name))">Minstens 2 karakters, cijfers niet toegestaan.</span>
                            <span v-if="(!isEmptyOrNull(paxInfo.homesteader_name) && paxInfo.homesteader_name.match(/[^\w\s-]/gi))">Speciale karakters zijn niet toegestaan.</span>
                            <span v-if="!isEmptyOrNull(paxInfo.homesteader_name) && (paxInfo.homesteader_name.indexOf(' ') > 0 || paxInfo.homesteader_name.indexOf('.') > 0 || paxInfo.homesteader_name.indexOf(',') > 0)">Geen spatie, komma of punt.</span>
                          </span>

                        <input
                            v-model="paxInfo.homesteader_name"
                            type="text"
                            size="10"
                            class="width100 requiredfield"
                            placeholder="Vul naam van thuisblijver in"
                        />
                      </div>

                    </div>

                      <div class="flexbox">
                        <div>Telefoonnummer:
                          <span class="rood">*
                            <span v-if="(showWarnings || isInvalidPhoneNumber) && isEmptyOrNull(paxInfo.homesteader_phone)">We missen een telefoonnummer.</span>
                            <span v-if="(isInvalidPhoneNumber(paxInfo.homesteader_phone))">Zorg ervoor dat telefoonnnummer voldoet aan de volgende indeling +landnummer gevolgd door je telefoonnummer. Bijvoorbeeld: +31107200500</span>
                          </span>

                        <input
                            v-model="paxInfo.homesteader_phone"
                            type="text"
                            size="10"
                            class="width100 requiredfield"
                            value=""
                            placeholder="+31107200500"
                        />
                      </div>

                    </div>
                    <div class="clearfix"></div>
                </div>

              <div
                    v-if="true"
                    class="midblock padding15 shadow marginbottom10 tform"
                >
                    <div class="floatleft width100">
                        Ruimte voor opmerkingen:
                    </div>
                    <div class="floatleft width100">
                        <textarea
                            v-model="paxInfo.opmerking"
                            id="testPaxOpmerking"
                            style="box-sizing: border-box;border: 1px solid rgba(0,0,0,0.4);"
                            class="width100"
                            placeholder="(Optioneel)"
                        ></textarea>
                    </div>
                    <div class="clearfix"></div>
                </div>
            </div>

            <div class="clear"></div>
            <div class="clear">&nbsp;</div>
            <div class=" padding15 ">
                <div
                    v-if="!offerReceived && !cruise.searchFlights && false"
                    class="font14 marginbottom10 width100"
                >
                    <h3>
                        <span v-if="cruise.searchFlights && !rivierOnly && false">Offerte</span>
                        <span v-else>Vrijblijvende reservering</span>
                        aanvragen
                    </h3>

                    <div class="marginbottom10">
                        Wij gaan na ontvangst van de aanvraag direct aan de slag
                        om alle reisonderdelen vrijblijvend in reservering te
                        zetten. De aanvraag is onder voorbehoud van
                        prijswijziging en beschikbaarheid.
                    </div>

                    <div
                        class="width100 rood paddingbottom10"
                        v-if="showWarnings"
                        style="text-align:center;"
                        rows="4"
                        v-show="nameWarn || emailWarn"
                    >
                        We missen 1 of meer verplichte velden voor het verwerken
                        van je vrijblijvende offerte aanvraag.
                    </div>

                    <div>
                        <button
                                v-if="!offerReceived && cruise.searchFlights && !rivierOnly && false"
                                v-on:click="validateFormForOffer"
                                :class="{
                            'btn-light': cruise.searchFlights,
                            'btn-success': !cruise.searchFlights,
                        }"
                                id="testOfferteAanvragen"
                                class="btn btn-addon width100 font16 bold uppercase tcenter margintop10 marginbottom20"
                        >
                            Offerte aanvragen
                        </button>
                        <button
                                v-if="!offerReceived && cruise.searchFlights && rivierOnly"
                                v-on:click="validateFormForOffer"
                                :class="{
                            'btn-light': cruise.searchFlights,
                            'btn-success': !cruise.searchFlights,
                        }"
                                id="testOfferteAanvragen"
                                class="btn btn-addon width100 font16 bold uppercase tcenter margintop10 paddingbottom10"
                        >
                            Vrijblijvende reservering
                        </button>

                    </div>
                    <button
                        v-if="!offerReceived && !cruise.searchFlights"
                        v-on:click="validateFormForOffer"
                        :class="{
                            'btn-light': cruise.searchFlights,
                            'btn-success': !cruise.searchFlights,
                        }"
                        id="testOfferteAanvragen"
                        class="btn btn-addon width100 font16 bold uppercase tcenter margintop10 paddingbottom10"
                    >
                        Vrijblijvende reservering
                    </button>
                </div>

                <div
                    v-if="offerReceived"
                    class="top-notification font14 width97 margintop20"
                    id="testOfferRecieved"
                >
                    <h3>Bedankt voor je aanvraag</h3>
                    Wij hebben je aanvraag met referentie:
                    <b>{{ dossiernummer }}</b> ontvangen en zullen je wensen
                    omzetten in een vrijblijvende
                    <span v-if="cruise.searchFlights">offerte.</span>
                    <span v-else="">reservering.</span>
                    Een van onze cruise specialisten zal binnen 24 uur contact
                    met je opnemen om de aanvraag verder door te nemen.<br />

                    Wil je graag nu direct met een van onze collega's spreken
                    dan helpen we je graag verder. Je kan ons bereiken op
                    <a href="tel:0107200500">010 - 7 200 500</a>

                    <div
                        v-if="!cruise.searchFlights && offerReceived"
                        class="tcenter paddingtop10"
                    >
                        <a :href="'/cruise/' + cruise.id" style="">
                            <span class="bold font14">
                                Keer terug naar de website
                            </span>
                        </a>
                    </div>
                </div>

                <div
                    v-if="cruise.searchFlights"
                    :class="{
                        'yellow-notification': offerReceived,
                        font14: true,
                        width97: true,
                        margintop20: true,
                    }"
                >
                  <div v-if="rivierOnly">
                      <h3>Je cruise is vrijblijvend gereserveerd</h3>
                      Wij houden de cruise en je gekozen hut kosteloos een aantal dagen voor je vast,
                      zo heb jij de tijd om vrij te regelen of nog even na te denken of je deze wilt bevestigen.
                      Wil je toch direct boeken? Controleer dan je gegevens en ga door naar betalen.
                  </div>

                </div>
                <div
                    class="rood paddingbottom10 paddingtop20 width100"
                    v-if="showWarnings && showWarningChange"
                    style="text-align:center;"
                >
                    We missen 1 of meer verplichte velden voor het verwerken van
                    je boeking.
                </div>
                <button
                    v-if="cruise.searchFlights || true"
                    v-on:click="validateForm()"
                    id="testCruiseBoeken"
                    onclick="window.scrollTo(0, 0);"
                    style="width: 100%;white-space:initial;"
                    class="btn btn-success btn-addon margintop10 font18 bold uppercase tcenter margin20"
                >
                    Ga door <font-awesome-icon icon="angle-right" />
                </button>

                <div class="margintop20 marginbottom10 tcenter">
                    <span class="paddingright20"
                        ><font-awesome-icon icon="check" class="green" />
                        Laagsteprijsgarantie</span
                    >
                    <span class="paddingright20"
                        ><font-awesome-icon icon="check" class="green" /> Geen
                        boekingskosten</span
                    >
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Passenger from './Passenger.vue'
import Discount from './Discount.vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCheck } from '@fortawesome/free-solid-svg-icons'

library.add(faCheck)
export default {
    name: 'PaxInfo',
    components: {
        Passenger,
        Discount,
    },
    data: function() {
        return {
            showWarnings: false,
            warnings: [],
            emailWarn: false,
            nameWarn: false,
            cardNumber: null,
        }
    },
    props: {
        paxInfo: Object,
        homesteader: Object,
        nationalities: Object,
        countries: Object,
        cruise: Object,
        flightPrice: Number,
        offerReceived: Boolean,
        dossiernummer: String,
        discount: Object,
        roundPrice: Function,
        payment: Object,
    },
    computed:{
        // Check if riviercruises
        rivierOnly: function() {
            var host = window.location.hostname
            //var host = 'rivier' dev
            return host.includes("rivier");
        },
    },
    methods: {
        isEmptyOrNull: function(str) {
            return str === '' || str === null || typeof str === 'undefined'
        },
      isInvalidPhoneNumber: function(str) {

        if(( str === '' || str === null || typeof str === 'undefined')) {

          return false
        }

        return !/^([+])([0-9]*)\w+$/.test(str)
      },
      isInvalidEmail: function(str) {
        if (str === '' || str === null || typeof str === 'undefined') {
          return true;
        }
         return !str.match(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/);
      },
      isInvalidName: function(str) {
        if (str === '' || str === null || typeof str === 'undefined') {
          return true;
        }
        return !(str.match(/^[^0-9]{2,}$/));
      },
        age: function(geboortedatum) {
            return this.moment(this.cruise.begindatum, 'YYYY-MM-DD').diff(
                geboortedatum,
                'years'
            )
        },


      showWarningChange: function() {
            let self = this
            let valid = true
            this.paxInfo.collection.forEach(function(pax, i) {
                if (pax.voornaam != null) {
                  pax.voornaam = pax.voornaam.replace("/", " ");
                }
                if (pax.achternaam != null) {
                  pax.achternaam = pax.achternaam.replace("/", " ");
                }
                // check info for every passenger
                if (
                    self.isEmptyOrNull(pax.voornaam) ||
                    self.isEmptyOrNull(pax.achternaam) ||
                    self.isInvalidName(pax.voornaam) ||
                    self.isInvalidName(pax.achternaam) ||
                    self.isEmptyOrNull(pax.jaar) ||
                    self.isEmptyOrNull(pax.maand) ||
                    self.isEmptyOrNull(pax.dag) ||
                    pax.voornaam.match(/[^\w\s-]/gi) ||
                    pax.achternaam.match(/[^\w\s-]/gi)
                ) {
                    valid = false
                }
                // check if multiple names are used
                if (
                    pax.voornaam !== null &&
                    (pax.voornaam.indexOf(' ') > 0 ||
                        pax.voornaam.indexOf('.') > 0 ||
                        pax.voornaam.indexOf(',') > 0)
                ) {
                    valid = false
                }
                pax.geboortedatum = self
                    .moment([pax.jaar, pax.maand - 1, pax.dag])
                    .format('YYYY-MM-DD')
                if (pax.geboortedatum === 'Invalid date') {
                    return false
                }
                let age = self.age(pax.geboortedatum)
                if (isNaN(age)) {
                    return false
                }
                if (pax.maxAge !== null && age > pax.maxAge) {
                    return false
                }
                console.log(age < pax.minAge);

                if (age < pax.minAge) {
                    return false
                }

                // check mail  && phone for main passenger
                if (
                    i == 0 &&
                    (self.isEmptyOrNull(pax.telefoonnummer) ||
                        self.isEmptyOrNull(pax.emailadres) ||
                        self.isInvalidEmail(pax.emailadres) ||
                        self.isInvalidPhoneNumber(pax.telefoonnummer)  ||
                        self.isEmptyOrNull(pax.huisnummer) ||
                        self.isEmptyOrNull(pax.straat) ||
                        self.isEmptyOrNull(pax.plaatsnaam) ||
                        self.isEmptyOrNull(pax.postcode))
                ) {
                    valid = false
                }
            })
            if (valid) {
                this.showWarnings = false
            }
        },
        validateForm: function() {
            let self = this
            let valid = true
            self.showWarnings = true
            this.paxInfo.collection.forEach(function(pax, i) {
                if (pax.voornaam != null) {
                  pax.voornaam = pax.voornaam.replace("/", " ");
                }
                if (pax.achternaam != null) {
                  pax.achternaam = pax.achternaam.replace("/", " ");
                }
                // check info for every passenger
                if (
                    self.isEmptyOrNull(pax.voornaam) ||
                    self.isEmptyOrNull(pax.achternaam) ||
                    self.isInvalidName(pax.voornaam) ||
                    self.isInvalidName(pax.achternaam) ||
                    self.isEmptyOrNull(pax.jaar) ||
                    self.isEmptyOrNull(pax.maand) ||
                    self.isEmptyOrNull(pax.dag) ||
                    pax.voornaam.match(/[^\w\s-]/gi) ||
                    pax.achternaam.match(/[^\w\s-]/gi)
                ) {
                    valid = false
                }
                // check if multiple names are used
                if (
                    pax.voornaam !== null &&
                    (pax.voornaam.indexOf(' ') > 0 ||
                        pax.voornaam.indexOf('.') > 0 ||
                        pax.voornaam.indexOf(',') > 0)
                ) {
                    valid = false
                }
                pax.geboortedatum = self
                    .moment([pax.jaar, pax.maand - 1, pax.dag])
                    .format('YYYY-MM-DD')
                if (pax.geboortedatum === 'Invalid date') {
                  valid = false
                }
                let age = self.age(pax.geboortedatum)
                if (isNaN(age)) {
                  valid = false
                }
                if (pax.maxAge !== null && age > pax.maxAge) {
                  valid = false
                }
                if (age < pax.minAge) {
                  valid = false
                }

                // check mail  && phone for main passenger
                if (
                    i == 0 &&
                    (self.isEmptyOrNull(pax.telefoonnummer) ||
                        self.isEmptyOrNull(pax.emailadres) ||
                        self.isInvalidEmail(pax.emailadres) ||
                        self.isInvalidPhoneNumber(pax.telefoonnummer)
                        ||
                        self.isEmptyOrNull(pax.huisnummer) ||
                        self.isEmptyOrNull(pax.straat) ||
                        self.isEmptyOrNull(pax.plaatsnaam) ||
                        self.isEmptyOrNull(pax.postcode))
                ) {
                    valid = false
                }
            })

            if(this.cruise.rederij_id == 31){
              if (
                  self.isEmptyOrNull(this.paxInfo.homesteader_name) ||
                  self.isInvalidName(this.paxInfo.homesteader_name) ||
                  this.paxInfo.homesteader_name.match(/[^\w\s-]/gi) ||
                  this.paxInfo.homesteader_name.indexOf(' ') > 0 ||
                  this.paxInfo.homesteader_name.indexOf('.') > 0 ||
                  this.paxInfo.homesteader_name.indexOf(',') > 0 ||

                  self.isInvalidPhoneNumber(this.paxInfo.homesteader_phone) ||
                  self.isEmptyOrNull(this.paxInfo.homesteader_phone)
              ) {
                valid = false
              }
            }

            self.savePaxInfoToLocalStorage()
            if (valid) {
                this.showWarnings = false
                this.$emit('paxinfo-valid-click')
            }
        },
        validateFormForOffer: function() {
            this.emailWarn = false
            this.nameWarn = false
            this.showWarnings = false

            // update passenger bdate from 3 dropdowns
            let self = this
            this.paxInfo.collection.forEach(function(pax) {
                pax.geboortedatum = self
                    .moment([pax.jaar, pax.maand - 1, pax.dag])
                    .format('YYYY-MM-DD')
            })

            if (
                this.isEmptyOrNull(this.paxInfo.collection[0].telefoonnummer) &&
                this.isEmptyOrNull(this.paxInfo.collection[0].emailadres)
            ) {
                this.emailWarn = true
            }

            if (
                this.isEmptyOrNull(this.paxInfo.collection[0].voornaam) &&
                this.isEmptyOrNull(this.paxInfo.collection[0].achternaam)
            ) {
                this.nameWarn = true
            }

            if (!this.emailWarn && !this.nameWarn) {
                this.$emit('createOffer-click')
            }
        },
        savePaxInfoToLocalStorage() {
            let paxInfoPayload = {}
            paxInfoPayload.obj = this.paxInfo
            localStorage.paxInfoPayload = JSON.stringify(paxInfoPayload)
        },
    },
}
</script>

<style>
.red-notification {
    background-color: #fbe8e7 !important;
    border: 1px solid #ffa9a9 !important;
}
.orange-notification {
    background-color: #fbf3e7 !important;
    border: 1px solid #ffe2a9 !important;
}

@media only screen and (max-width: 500px) {
    .paxinfo {
        margin-right: 12px;
    }
}

.flexrow {
  display: flex;
  width:100%;
  .flexbox {
    width:50%;
    padding-right: 10px;
    box-sizing: border-box;
    display: flex;
    flex-flow:column;
    .nextline {
      .select-drop {
        margin-right:10px;
      }
    }
  }
  margin-bottom:10px;
}

.flex3 .flexbox {
  width: calc(100% / 3);
}
@media screen and (max-width: 1024px) {
  .flexrow
  {
    .flexbox {
      width: 100% !important;
    }
    flex-flow: column;
    margin-top:5px;

  }
  .width20,
  .width40 {
    width: 100%;
  }
  .nextline {
    width: 100% !important;
    float: left;
    padding: 0;
  }
  .nextline .width20 {
    width: calc((100% / 3) - 10px) !important;
    margin: 0 5px;
  }
  .nextline:first-child {
    margin-left: 0;
  }
  .nextline:nth-last-child {
    margin-right: 0;
  }
  .select-drop select {
    width: 100%;
    margin-top: 5px;
    margin-bottom: 5px;
  }
}
</style>